import React from 'react';
import { Autocomplete } from '@material-ui/lab';
import { makeStyles } from '@material-ui/styles';
import { useTranslation } from 'react-i18next';
import {
  Checkbox,
  Container,
  FormControlLabel,
  TextField,
  Typography,
} from '@material-ui/core';

const FeaturedCourseCard = ({
  name,
  title,
  fields,
  onSelected,
  checkedList,
  setCheckedList,
}) => {
  const classes = useStyles();
  const [search, setSearch] = React.useState('');
  const [value, update] = React.useState(false);
  const { t } = useTranslation(['form']);

  return (
    <React.Fragment>
      <Typography className={classes.fullWidthSpan}>{title}</Typography>
      <Autocomplete
        fullWidth
        clearOnEscape
        options={fields ? fields : []}
        getOptionLabel={(option) => option?.name}
        onChange={(e, value) => {
          setSearch(value?.id ? value?.id : '');
        }}
        renderInput={(params) => (
          <TextField
            {...params}
            fullWidth
            margin="normal"
            label={t('form:Teams.search_field', { name })}
            variant="outlined"
          />
        )}
      />
      <Container className={classes.selectField}>
        {fields?.map((field) => {
          return (
            <div key={field?.id} hidden={search.length && search !== field?.id}>
              <FormControlLabel
                style={{ width: '100%' }}
                control={
                  <Checkbox
                    checked={checkedList
                      ?.map(({ id }) => id)
                      ?.includes(field.id)}
                    onChange={(e, checked) => {
                      if (checked) {
                        checkedList.push({ id: field.id, name: field.name });
                      } else {
                        setCheckedList(
                          checkedList.filter(({ id }) => id !== field.id)
                        );
                      }
                      update(!value);
                      if (onSelected) {
                        onSelected({ id: field.id, name: field.name }, checked);
                      }
                    }}
                  />
                }
                label={field?.name}
              />
            </div>
          );
        })}
      </Container>
    </React.Fragment>
  );
};

const useStyles = makeStyles((theme) => ({
  fullWidthSpan: {
    display: 'block',
    lineHeight: '100%',
    width: '100%',
    fontWeight: '600',
    fontSize: 'medium',
    marginTop: theme.spacing(4),
  },

  selectField: {
    height: 250,
    overflowY: 'scroll',
    overflowX: 'hidden',
    marginTop: theme.spacing(1),
    padding: 0,
  },
}));

export default FeaturedCourseCard;
